// Exact copy of the API's text.ERROR.USER_DEACTIVATED message
// (tempstars-api/src/utils/text-constants.ts). If the API ever changes this
// string we rely on the `startsWith` check below to still match.
export const DEACTIVATED_ACCOUNT_PREFIX = 'This account was previously deleted';
export const DEACTIVATED_ACCOUNT_MESSAGE =
	'This account was previously deleted, please contact support for further assistance.';

export const GENERIC_LOGIN_ERROR = 'Username or password is incorrect';

/**
 * Resolves the user-facing error message for a failed login attempt.
 *
 * Historically the catch block piped `e.message` straight into the UI, which
 * leaked raw backend/DB errors (see commit 85450d24). Commit 85450d24 replaced
 * that with a hard-coded generic message — which hid the legitimate
 * "deactivated account" message for deleted users (T2-5751).
 *
 * This helper splits the difference: show the deactivated-account message
 * when the API says so (HTTP 404 with the USER_DEACTIVATED string), and the
 * generic credentials message for anything else.
 */
export const resolveLoginErrorMessage = (error: unknown): string => {
	const status = (error as { status?: number } | null)?.status;
	const rawMessage = (error as { message?: unknown } | null)?.message;

	if (status !== 404 || typeof rawMessage !== 'string') {
		return GENERIC_LOGIN_ERROR;
	}

	// Express's res.json(string) wraps the value in double-quotes; strip those
	// wrapping quotes before comparing.
	const cleanMessage = rawMessage.replace(/^["']+|["']+$/g, '');

	if (cleanMessage.startsWith(DEACTIVATED_ACCOUNT_PREFIX)) {
		return cleanMessage;
	}

	return GENERIC_LOGIN_ERROR;
};
